import i18next from "i18next";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import t from "../locales/nl/terms.json";
import ReactGA from 'react-ga4'
import TopLogo from "../components/logo/top_logo";
import TextLogo from "../components/logo/text_logo";

function TermsConditions() {

    ReactGA.send({hitType: "pageView", page: "/terms", title: "TermsPage"})

    const [scrolled, setScrolled] = useState(false);
    const [mobileNavOpen, setMobileNavOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 10);
        onScroll();
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const onButtonClick = () => {
        const pdf = i18next.language === "nl" ? "Algemene voorwaarden VersaIT.pdf" : "Terms and Conditions VersaIT.pdf"
        // using Java Script method to get PDF file
        fetch(pdf).then(response => {
            response.blob().then(blob => {
                // Creating new object of PDF file
                const fileURL = window.URL.createObjectURL(blob)
                // Setting various property values
                let alink = document.createElement('a')
                alink.href = fileURL
                alink.download = pdf
                alink.click()
            })
        })
        ReactGA.event({category: "User", action: "fileDownload"})
    }

    return (
    <div className="versa">
      <style>{`
        :root{
          --bg:#f7f8fb;
          --accent:#0b74ff;
          --muted:#6b7280;
          --card:#ffffff;
          --glass: rgba(255,255,255,0.6);
          --radius:16px;
          --maxw:1200px;
        }

        *{box-sizing:border-box}
        html,body,#root{height:100%;}
        body{
          margin:0;font-family:Inter,ui-sans-serif,system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue",Arial;
          background: linear-gradient(180deg,var(--bg), #ffffff 60%);
          color:#0f172a; -webkit-font-smoothing:antialiased; -moz-osx-font-smoothing:grayscale;
        }

        .versa{min-height:100vh;display:flex;flex-direction:column;align-items:center}

        /* NAV */
        .nav{
          position:fixed;top:16px;left:50%;transform:translateX(-50%);
          width:calc(100% - 40px);max-width:var(--maxw);z-index:60;transition:all 0.35s ease;
          display:flex;align-items:center;justify-content:space-between;padding:10px 14px;border-radius:12px;
        }
        .nav--transparent{background:transparent;box-shadow:none}
        .nav--solid{background:rgba(255,255,255,0.95);backdrop-filter: blur(6px);box-shadow:0 6px 24px rgba(17,24,39,0.06);}

        .brand{display:flex;align-items:center;gap:10px}
        .logo{width:42px;height:42px;border-radius:10px;display:flex;align-items:center;justify-content:center;}
        .brand h1{font-size:16px;margin:0}
        .brand p{margin:0;font-size:10px;color:var(--muted)}

        .nav-links{display:flex;gap:18px;align-items:center}
        .nav-links a{color:var(--muted);text-decoration:none;font-weight:600}
        .cta-btn{padding:10px 14px;border-radius:10px;background:linear-gradient(90deg,var(--accent),#2bb0ff);color:white;border:none;font-weight:700;cursor:pointer}

        .mobile-toggle{display:none;border:1px solid rgba(15,23,42,0.06);padding:8px;border-radius:8px;background:white}

        /* Terms */
        .terms-content{padding:24px; margin-top:80px;}

        /* FOOTER */
        footer{width:100%;max-width:var(--maxw);padding:24px;display:flex;justify-content:space-between;align-items:center;color:var(--muted)}

        /* responsiveness */
        @media (max-width:640px){
          .nav{left:12px;right:12px;transform:none;width:calc(100% - 24px)}
          .nav-links{display:none}
          .mobile-toggle{display:block}
        }

        /* little UI niceties */
        .fade-in{opacity:0;transform:translateY(8px);animation:fadeIn 0.6s forwards}
        @keyframes fadeIn{to{opacity:1;transform:none}}

      `}</style>

      <nav className={`nav ${scrolled || mobileNavOpen ? "nav--solid" : "nav--transparent"}`} aria-label="Hoofdnavigatie">
        <button onClick={()=>window.location.href='/'} style={{padding: 0, background:'transparent',border:'none',cursor:'pointer'}}>
          <div className="brand">
            {/* logo */}
            <div className="logo">
              <TopLogo className={"App-logo"}/>
            </div>

            {/* Title */}
            <div>
              <div style={{height: "30px", display: "flex", justifySelf: "left"}}>
                <TextLogo className={"App-logo"} />
              </div>
              <p className="muted">Powered by Wessel Koopman</p>
            </div>
          </div>
        </button>

        <div className="nav-links" role="navigation" aria-label="Linklijst">
          <a href="/#services">Diensten</a>
          <a href="/#features">Voordelen</a>
          {/* <a href="#testimonials">Referenties</a> */}
          <a href="/#contact" className="cta-btn" style={{color:'white'}} onClick={(e)=>{e.preventDefault();document.getElementById('contact')?.scrollIntoView({behavior:'smooth'})}}>Contact</a>
        </div>

        <button className="mobile-toggle" aria-expanded={mobileNavOpen} onClick={()=>setMobileNavOpen(s=>!s)}>
          {mobileNavOpen ? 'Sluit' : 'Menu'}
        </button>
      </nav>

      {/* mobile nav overlay */}
      {mobileNavOpen && (
        <div style={{position:'fixed',inset:0,zIndex:50,background:'rgba(2,6,23,0.45)'}} onClick={()=>setMobileNavOpen(false)}>
          <div style={{position:'absolute',right:18,top:84,background:'white',padding:18,borderRadius:12,minWidth:200}} onClick={(e)=>e.stopPropagation()}>
            <a href="/#services" onClick={()=>setMobileNavOpen(false)} style={{display:'block',padding:'10px 0'}}>Diensten</a>
            <a href="/#features" onClick={()=>setMobileNavOpen(false)} style={{display:'block',padding:'10px 0'}}>Voordelen</a>
            {/* <a href="#testimonials" onClick={()=>setMobileNavOpen(false)} style={{display:'block',padding:'10px 0'}}>Referenties</a> */}
            <a href="/#contact" onClick={()=>{setMobileNavOpen(false);document.getElementById('contact')?.scrollIntoView({behavior:'smooth'})}} style={{display:'block',padding:'10px 0'}}>Contact</a>
          </div>
        </div>
      )}

      <div className="terms-content">
      
          <button className="cta-btn" onClick={onButtonClick}>
              <FontAwesomeIcon icon={faDownload} /> &nbsp; { t['terms'] }
          </button>

          <h1>{ t['terms-and-conditions'] }</h1>
          <p>{ t['terms-and-conditions-applicable'] }</p>
          <p>{ t['terms-and-conditions-binding'] }</p>
          
          <h2>{ t['1.'] }</h2>
          <p>{ t['1.1.'] }</p>
          <p>{ t['1.2.'] }</p>
          <p>{ t['1.3.'] }</p>
          <p>{ t['1.4.'] }</p>
          <p>{ t['1.5.'] }</p>
          <p>{ t['1.6.'] }</p>
          <p>{ t['1.7.'] }</p>
          
          <h2>{ t['2.'] }</h2>
          <p>{ t['2.1.'] } </p>
          <p>{ t['2.2.'] }</p>
          <p>{ t['2.3.'] }</p>
          <p>{ t['2.4.'] }</p>
          <p>{ t['2.5.'] }</p>
          <p>{ t['2.6.'] }</p>
          
          <h2>{ t['3.'] }</h2>
          <p>{ t['3.1.'] }</p>
          <p>{ t['3.2.'] }</p>
          <p>{ t['3.3.'] }</p>
          <p>{ t['3.4.'] }</p>
          <p>{ t['3.5.'] }</p>
          <p>{ t['3.6.'] }</p>
          <p>{ t['3.7.'] }</p>
          <p>{ t['3.8.'] }</p>

          <h2>{ t['4.'] }</h2>
          <p>{ t['4.1.'] }</p>
          <p>{ t['4.2.'] }</p>
          <p>{ t['4.3.'] }</p>
          <p>{ t['4.4.'] }</p>
          <p>{ t['4.5.'] }</p>
          <p>{ t['4.6.'] }</p>
          <p>{ t['4.7.'] }</p>

          <h2>{ t['5.'] }</h2>
          <p>{ t['5.1.'] }</p>
          <p>{ t['5.2.'] }</p>
          <p>{ t['5.3.'] }</p>
          <p>{ t['5.4.'] }</p>
          <p>{ t['5.5.'] }</p>

          <h2>{ t['6.'] }</h2>
          <p>{ t['6.1.'] }</p>
          <p>{ t['6.2.'] }</p>
          <p>{ t['6.3.'] }</p>
          <p>{ t['6.4.'] }</p>

          <h2>{ t['7.'] }</h2>
          <p>{ t['7.1.'] }</p>
          <p>{ t['7.2.'] }</p>
          <p>{ t['7.3.'] }</p>

          <h2>{ t['8.'] }</h2>
          <p>{ t['8.1.'] }</p>
          <p>{ t['8.2.'] }</p>
          <p>{ t['8.3.'] }</p>
          <p>{ t['8.4.'] }</p>
          <p>{ t['8.5.'] }</p>

          <h2>{ t['9.'] }</h2>
          <p>{ t['9.1.'] }</p>
          <p>{ t['9.2.'] }</p>
          <p>{ t['9.3.'] }</p>
          <p>{ t['9.3.a'] }</p>
          <p>{ t['9.3.b'] }</p>
          <p>{ t['9.3.c'] }</p>
          <p>{ t['9.3.d'] }</p>
          <p>{ t['9.4.'] }</p>
          <p>{ t['9.5.'] }</p>
          <p>{ t['9.6.'] }</p>
          <p>{ t['9.7.'] }</p>

          <h2>{ t['10.'] }</h2>
          <p>{ t['10.1.'] }</p>
          <p>{ t['10.2.'] }</p>
          <p>{ t['10.3.'] }</p>
          <p>{ t['10.4.'] }</p>
          <p>{ t['10.5.'] }</p>

          <h2>{ t['11.'] }</h2>
          <p>{ t['11.1.'] }</p>
          <p>{ t['11.2.'] }</p>
          <p>{ t['11.3.'] }</p>
          <p>{ t['11.4.'] }</p>
          <p>{ t['11.5.'] }</p>
      </div>
      <footer>
          <div>© {new Date().getFullYear()} VersaIT — Alle rechten voorbehouden</div>
          <div style={{display:'flex',gap:12}}>
          <a href="/Privacy_Statement" style={{color:'var(--muted)',textDecoration:'none'}}>Privacy</a>
          <a href="/Terms_and_Conditions" style={{color:'var(--muted)',textDecoration:'none'}}>Voorwaarden</a>
          </div>
      </footer> 
    </div>
    )
}

export default TermsConditions;